import { CellContext } from "@tanstack/react-table"

import { UITypes } from "types"

import styles from "./index.module.scss"

interface Props {
  cell: CellContext<UITypes.TableBodyRow, UITypes.TableBodyCell>
}

const StatusCell = ({ cell }: Props) => {
  const value = cell.getValue().value

  return <span className={styles.status}>{String(value || "").toUpperCase()}</span>
}

export default StatusCell
